import { useEffect } from 'react'
import { siteName } from '../functions/siteName'

// Der Seitentitel der App steht vor dem Namen der Website. Nicht vor dem
// Titel, den WordPress geliefert hat: der benennt die Seite seit #101 selbst
// („Stellenangebote - Job4u", „Messe Oldenburg – Weser-Ems-Hallen … - Job4u"),
// und davor gestellt stand der Name der Seite zweimal im Tab. Ohne Seitentitel
// (noch am Laden) bleibt der Servertitel, der ist fuer den ersten Aufruf schon
// richtig.
export const useDocumentTitle = (seitentitel) => {
    useEffect(() => {
        if (!seitentitel) return
        const name = siteName()
        document.title = name ? `${seitentitel} – ${name}` : seitentitel
    }, [seitentitel])
}
